import type {MetlQueueExport} from "../metl-models/exports/MetlQueueExport.ts";
import type {AxiosInstance} from "axios";
import type {MetlApi} from "./MetlApiBase.ts";

export interface MetlQueueApi extends MetlApi {
    export(): Promise<MetlQueueExport>
}

export function metlQueueApi(axios: AxiosInstance, baseUrl: string, id: string): MetlQueueApi {
    return {
        id,
        export: () => axios.get(`${baseUrl}/export`).then(x => x.data)
    }
}